import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/ShopCard.css";
import { FaMapMarkerAlt } from "react-icons/fa";

function FruitShopCard() {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const sliderRef = React.useRef(null);

  useEffect(() => {
    const fetchShops = async () => {
      try {
        const response = await fetch(
          "https://yaasaai.com/myphpapi/allFruitShops.php"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch shops.");
        }
        const data = await response.json();

        if (!data.success || !Array.isArray(data.data)) {
          throw new Error(
            "Invalid data format: Expected an array inside 'data'"
          );
        }

        setShops(data.data);
      } catch (err) {
        console.error("Error fetching shop data:", err);
        setError("Error loading shops. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchShops();
  }, []);

  const handleVisitShop = (shopId) => {
    const userEmail = sessionStorage.getItem("userEmail");
    //track script
    if (typeof window.gtag === "function") {
      window.gtag("event", "shop_fruit_visit", {
        shop_id: shopId,
        user_id: userEmail || "unknown",
      });
    }

    navigate("/shop_profile", { state: { userEmail, shopId } });
  };

  // Responsive settings for the carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 8 } },
      { breakpoint: 1024, settings: { slidesToShow: 6 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 600, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 3 } },
      { breakpoint: 360, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <div className="shop-container">
      <h5 align="center">Fruit Shops</h5>
      <div className="carousel-container">
        <Button
          variant="success"
          className="slider-button prev"
          onClick={() => sliderRef.current.slickPrev()}
        >
          &#10094;
        </Button>
        <Slider ref={sliderRef} {...settings}>
          {shops.length > 0 ? (
            shops.map((shop) => {
              const imageUrl = `https://yaasaai.com/ShopImages/${shop.shop_image}`;

              return (
                <div key={shop.shop_id}>
                  <Card style={{ width: "7rem" }} className="shop-card">
                    <div
                      style={{
                        width: "110px",
                        height: "100px",
                      }}
                    >
                      <Card.Img
                        variant="top"
                        src={imageUrl}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          imageRendering: "auto",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "default-image.jpg";
                        }}
                        className="veg-image img-fluid rounded"
                      />
                    </div>

                    <Card.Body>
                      <Card.Title
                        className="shop_title"
                        style={{ fontSize: "10px" }}
                      >
                        {shop.shop_name}
                      </Card.Title>

                      <Card.Title style={{ fontSize: "8px", color: "green" }}>
                        open 11 am
                      </Card.Title>

                      <Card.Text className="shop-address">
                        <strong>
                          <FaMapMarkerAlt
                            size={10}
                            className="blinking-icon me-1"
                          />
                        </strong>
                        {shop.shop_address}
                      </Card.Text>

                      {/* ✅ Show message if shop is closed */}
                      {shop.shop_quantity === "closed" ? (
                        <Card.Text
                          style={{
                            padding: "6px 12px",
                            fontSize: "12px",
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "arrow",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            transition: "0.3s",
                          }}
                        >
                          Closed
                        </Card.Text>
                      ) : (
                        <Button
                          onClick={() => handleVisitShop(shop.shop_id)}
                          style={{
                            padding: "6px 12px",
                            fontSize: "12px",
                            backgroundColor: "#4CAF50",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            transition: "0.3s",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.backgroundColor = "#45a049")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.backgroundColor = "#4CAF50")
                          }
                        >
                          Visit
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </div>
              );
            })
          ) : (
            <p align="center">No shops available</p>
          )}
        </Slider>

        <Button
          variant="success"
          className="slider-button next"
          onClick={() => sliderRef.current.slickNext()}
        >
          &#10095;
        </Button>
      </div>
    </div>
  );
}

export default FruitShopCard;
